export default "__VITE_PUBLIC_ASSET__fafae3f7__"